import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=5222a8f4&scoped=true&lang=pug"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"
import style0 from "./Banner.vue?vue&type=style&index=0&id=5222a8f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5222a8f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5222a8f4')) {
      api.createRecord('5222a8f4', component.options)
    } else {
      api.reload('5222a8f4', component.options)
    }
    module.hot.accept("./Banner.vue?vue&type=template&id=5222a8f4&scoped=true&lang=pug", function () {
      api.rerender('5222a8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/anniversary2023/components/Banner.vue"
export default component.exports